// @flow strict

import * as React from 'react'
import { NavigationItem } from '../NavigationComponents/NavigationItem'
import NavigationWrapper from '../NavigationComponents/NavigationContainer'
import paidNavStyles from './PaidNavigation.module.scss'
import paidNavListStyles from './PaidNavigationList.module.scss'
import TrackEvents from '../../../atoms/TrackEvents/TrackEvents'
import PaidButton from '../../../atoms/Button/PaidButton'
import { URLS } from '../../../../constants'
import { NAVIGATION_LINKS as DEFAULT_NAV_LINKS } from '../DefaultMainNavigation'

const paidNavLinks = DEFAULT_NAV_LINKS

export default () => {
  return (
    <NavigationWrapper
      activeContext="personal"
      styles={paidNavStyles}
      navigationListStyles={paidNavListStyles}
      navLinks={paidNavLinks}
      callToAction={
        <TrackEvents category="conversion" action="download app" label="header">
          <PaidButton href={URLS.ADJUST_BOTH_STORE}>Sign up</PaidButton>
        </TrackEvents>
      }
    >
      {paidNavLinks.map(props => (
        <NavigationItem
          {...props}
          key={props.text}
          navigationListStyles={paidNavListStyles}
        />
      ))}
    </NavigationWrapper>
  )
}
